<div style="padding: 24px;">
  <app-page-header title="Gestion de Prospectos" subtitle="Seguimiento y administracion de prospectos comerciales" />

  <p class="text-sm text-gray-400 mb-2">Haz clic en una etapa para filtrar los resultados</p>

  <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-6">
    <div
      class="rounded-lg border-l-4 bg-white shadow-sm px-5 py-4 cursor-pointer transition-all duration-200 hover:shadow-md"
      [class.ring-2]="activeStageFilter === null"
      [class.ring-offset-1]="activeStageFilter === null"
      style="border-left-color: #6b7280; --tw-ring-color: #6b7280"
      (click)="clearStageFilter()"
    >
      <div class="text-2xl md:text-3xl font-semibold" style="color: #6b7280">
        {{ allData.length }}
      </div>
      <div class="text-sm text-gray-500">Todos</div>
    </div>

    @for (stage of stageList; track stage.name) {
      <div
        class="rounded-lg border-l-4 bg-white shadow-sm px-5 py-4 cursor-pointer transition-all duration-200 hover:shadow-md"
        [class.ring-2]="activeStageFilter === stage.name"
        [class.ring-offset-1]="activeStageFilter === stage.name"
        [style.border-left-color]="stage.color"
        [style.--tw-ring-color]="stage.color"
        (click)="toggleStageFilter(stage.name)"
      >
        <div class="text-2xl md:text-3xl font-semibold" [style.color]="stage.color">
          {{ getStageCount(stage.name) }}
        </div>
        <div class="text-sm text-gray-500">{{ stage.name }}</div>
      </div>
    }
  </div>

  <app-data-table
    [data]="data"
    [columns]="columns"
    [loading]="isLoading"
    [pageSize]="10"
    [pageSizeOptions]="[10, 20, 50]"
    searchPlaceholder="Buscar por nombre, paso, etapa..."
    [showAddButton]="true"
    (add)="onAdd()"
  >
    <ng-template appCellTemplate="acciones" let-row>
      <app-button-actions
        [row]="row"
        [actions]="getActionsForRow(row)"
        (action)="onAction({ action: $event, row: row })"
      />
    </ng-template>
  </app-data-table>

  <app-prospect-modal
    [(visible)]="modalVisible"
    [prospect]="selectedProspect"
    (saved)="onModalSaved()"
  />

  <app-prospect-history-modal
    [(visible)]="historyModalVisible"
    [prospect]="selectedProspect"
  />

  <app-reschedule-modal
    [(visible)]="rescheduleModalVisible"
    [mode]="scheduleMode"
    [prospect]="selectedProspect"
    [googleEventId]="selectedProspect?.sgoogleeventid ?? null"
    (scheduled)="onScheduled($event)"
  />

  <app-prospect-documents-modal
    [(visible)]="documentsModalVisible"
    [prospectId]="selectedProspect?.fkIdProspecto ?? 0"
    (uploaded)="onDocumentUploaded($event)"
  />

  <app-acceptance-preview-modal
    [(visible)]="previewModalVisible"
    [prospect]="selectedProspect"
  />
</div>
